import { getGetFrontFilePathNomeFileQueryOptions } from '@framework/api-client';
import {
  IWidgetComponentProps,
  InputMarginContainer,
  RichTextAdvancedRender,
  getIconFromType,
  getWidgetProps,
  useWidgetEnabled,
  useWidgetVisibility,
} from '@framework/engine';
import { useTranslation } from '@framework/i18n';
import { AlignRow } from '@framework/ui';
import { Button, message } from 'antd';
import React from 'react';
import { useAuthDownload } from '../../../utils/download/useAuthDownload';
import { IDownloadWidget } from './IDownloadWidget';

export interface IDownloadWidgetComponentProps
  extends IWidgetComponentProps<IDownloadWidget> {}

/**
 * Widget per il download di un file
 */
export function DownloadWidgetComponent(props: IDownloadWidgetComponentProps) {
  const { widget } = props;
  const { t } = useTranslation();
  const options = getWidgetProps(props);

  const visible = useWidgetVisibility(props.widget, options);
  const enabled = useWidgetEnabled(widget, options);
  // Estraggo le informazioni necessarie per il download del file
  const [path, fileName] = widget.filePath?.split('/') ?? [];

  // Hook di antd necessario per gestire i messaggi
  // di loading durante le azioni di richiamo servizio
  const [messageApi, contextHolder] = message.useMessage();

  const { download, isFetching } = useAuthDownload(
    getGetFrontFilePathNomeFileQueryOptions,
    [path, fileName],
    {
      onError: e => {
        if (e.response?.status === 404) {
          message.error(
            t('download-widget.file-not-found', 'File non trovato'),
          );
          return;
        }

        message.error(t("download-widget.error", 'Si è verificato un problema durante il download del file. Riprovare.')); // prettier-ignore
      },
    },
  );

  if (!visible) return null;
  if (props.readonly) return null;

  return (
    <>
      {contextHolder}
      <InputMarginContainer>
        <AlignRow justify={widget.layout?.buttonAlign ?? 'flex-end'}>
          <Button
            size="large"
            block
            type={widget.layout?.buttonType ?? 'primary'}
            icon={getIconFromType(widget.layout?.iconType)}
            children={<RichTextAdvancedRender inline text={widget.label} />}
            disabled={enabled === false}
            loading={isFetching}
            onClick={download}
          />
        </AlignRow>
      </InputMarginContainer>
    </>
  );
}
